import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f5f0df6a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search-button" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-search fas" }, null, -1))
const _hoisted_3 = { class: "map" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_l_tile_layer = _resolveComponent("l-tile-layer")!
  const _component_l_tooltip = _resolveComponent("l-tooltip")!
  const _component_l_marker = _resolveComponent("l-marker")!
  const _component_marker_cluster = _resolveComponent("marker-cluster")!
  const _component_l_map = _resolveComponent("l-map")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createBlock(_component_el_card, { class: "sampling-point-map-wrapper" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_popover, {
          placement: "bottom",
          width: 500,
          trigger: "click"
        }, {
          reference: _withCtx(() => [
            _createVNode(_component_el_button, {
              class: "btn",
              type: "primary",
              size: "large",
              circle: ""
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_row, { gutter: 4 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 14 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.query,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.query) = $event)),
                      placeholder: _ctx.$t('placeholder.search')
                    }, null, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 5 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      class: "btn",
                      type: "primary",
                      onClick: _ctx.search,
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("placeholder.search")), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 5 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_tooltip, {
                      class: "box-item",
                      effect: "dark",
                      content: _ctx.$t('tooltip.refresh'),
                      placement: "bottom"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          class: "btn",
                          icon: _ctx.Refresh,
                          style: {"width":"100%"},
                          onClick: _ctx.onClear
                        }, null, 8, ["icon", "onClick"])
                      ]),
                      _: 1
                    }, 8, ["content"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_l_map, {
          ref: "map",
          "max-zoom": 21,
          center: _ctx.defPosition,
          zoom: _ctx.zoom,
          onReady: _ctx.onLeafletReady,
          options: _ctx.mapOptions
        }, {
          default: _withCtx(() => [
            (_ctx.leafletReady)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_l_tile_layer, { url: _ctx.url }, null, 8, ["url"]),
                  _createVNode(_component_marker_cluster, { options: { showCoverageOnHover: false, chunkedLoading: true } }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredSamPointsMap, (samplingPoint) => {
                        return (_openBlock(), _createBlock(_component_l_marker, {
                          key: samplingPoint.id,
                          "lat-lng": samplingPoint.latlon,
                          onClick: ($event: any) => (_ctx.openSamplingPointDetail(samplingPoint))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_l_tooltip, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(samplingPoint.name), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["lat-lng", "onClick"]))
                      }), 128))
                    ]),
                    _: 1
                  })
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["center", "zoom", "onReady", "options"])
      ])
    ]),
    _: 1
  }))
}